import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routers/gxqgouche2212/index.js'
Vue.use(VueRouter)
// const _base = process.env.NODE_ENV == 'development' ? '' : ''
export const router = new VueRouter({
  base: '/gxqgouche2212',
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem('gxqgc2212_auth_token') || to.fullPath == '/download') {
    next()
  } else {
    if (window.location.pathname != '/gxqgouche2212' && window.location.pathname != '/gxqgouche2212/') {
      window.location.href = window.location.origin + '/gxqgouche2212'
    } else {
      next()
    }
  }
})
router.afterEach(() => {
  // eslint-disable-next-line prettier/prettier
  (function () {
    // eslint-disable-next-line no-undef
    if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
      handleInitWx()
    } else {
      document.addEventListener('WeixinJSBridgeReady', handleInitWx, false)
    }
    function handleInitWx() {
      // 禁止分享
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call('hideOptionMenu')
      // 设置网页字体为默认大小
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      // 重写设置网页字体大小的事件
      // eslint-disable-next-line no-undef
      WeixinJSBridge.on('menu:setfont', function () {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      })
    }
  })()
})
Vue.router = router

export default {
  router
}
